import * as types from "../constants/mutation-types"
import * as sendData from "./senddata"

const onLogin = function (store, payload) {
    store.commit(types.SET_USER_ID, payload)
    store.commit(types.SET_LOADING_ROOM_DATA, true)
    if (store.state.isOpenChat) {
        sendData.sendGetRoom()
        store.commit(types.SET_LOAD_INIT_DATA, true)
    } else {
        setTimeout( () => {
            if (!store.state.loadInitData) {
                sendData.sendGetRoom()
                store.commit(types.SET_LOAD_INIT_DATA, true)
            }
        }, 2000)
        store.commit(types.SET_LOAD_INIT_DATA, false)
    }
}

const onChatMessage = function (store, msg) {
    store.commit(types.RECEIVE_MESSAGE, msg)
}

const onListRoom = function (store, playload) {
    store.commit(types.SET_LIST_ROOM, playload)
    store.commit(types.SET_LOADING_ROOM_DATA, false)
}

const onHistoryChat = function (store, payload) {
    store.commit(types.RECEIVE_HISTORY_MESSAGE, payload)
    store.commit(types.SET_IS_LOADING_MESSAGE, false)
    if (store.state.listResendMessage && store.state.listResendMessage.length > 0) {
        const listResend = store.state.listResendMessage
        store.commit(types.FREE_WAIT_MESSAGES, listResend)
        listResend.forEach(message => {
            store.dispatch('sendMessage', message)
        })
    }
}

const onUserStatus = function (store, payload) {
    store.commit(types.USER_ONLINE, payload)
}

const onReadMessage = function (store, payload) {
    store.commit(types.READ_MESSAGE, payload)
}

const onIncommingMessage = function (store, payload) {
    store.commit(types.INCOMMING_MESSAGE, payload)
}

export default {
    onLogin,
    onChatMessage,
    onListRoom,
    onHistoryChat,
    onUserStatus,
    onReadMessage,
    onIncommingMessage
}
